module.exports = __webpack_public_path__ + "img/fax-tag-close.4015e5cd.svg";